"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const component_link_1 = require("@patternplate/component-link");
const Url = require("url");
const queryString = require("query-string");
exports.MarkdownLink = (props) => {
    const abs = absolute(props.href);
    const query = abs ? {} : queryString.parse(Url.parse(props.href).query);
    return (React.createElement(StyledLink, { hint: true, href: props.href, query: query }, props.children));
};
const StyledLink = styled_components_1.default(component_link_1.Link) `
  font-size: 18px;
  line-height: 27px;
  color: ${props => props.theme.colors.color};
  text-decoration: none;
  &:link,
  &:visited {
    color: ${props => props.theme.colors.active};
  }
  &:hover,
  &:active {
    text-decoration: underline;
  }
`;
function absolute(href) {
    const parsed = Url.parse(href || "./");
    if (parsed.protocol) {
        return true;
    }
    if (href.startsWith("/api/static/")) {
        return true;
    }
}
//# sourceMappingURL=markdown-link.js.map